@if (kingService.game()?.status === 'part_waiting' && kingService.timer() !==
-1) {
  <div animate.enter="fade-in" class="timer-title">{{ kingService.timer() }} Seconds Left</div>
  <div animate.enter="fade-in" class="timer-bar">
    <div class="timer-bar__fill rounded-4"
         [style.width.%]="(kingService.timer() / kingService.timerTotal()) * 100">
    </div>
  </div>

} @else {
  <div animate.enter="fade-in" class="timer-placeholder">Join to begin the battle</div>
}
